import React ,{useEffect,useState} from 'react'
import { useParams } from 'react-router-dom';
import Student12TopMenu from "../studentInfo/student12topmenu"
import PageNotes from "../../pages/common/pagenotesnew";
import { getIdData } from "../../../lib/studentinfo";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentFinAid() {

  let { slug } = useParams();
   const [studentInfo, setStudentInfo] = useState();
    const { profile, setProfile } = useAuth();

    async function GetStudentData() {
        const std = await getIdData(slug);
        setStudentInfo(std);
        console.log("std", std);   
      }

useEffect(() => {
    GetStudentData();
}, [slug])

  return (
    <>
    <Student12TopMenu slug={slug} activeMenu={"Financial Aid"} />
    <div className="tak-instruct-group">
      <div className="row">
        <div className="col-md-12">    
        <PageNotes
              type={"Instructor"}
              pageName={"Financial Aid"}
              studentId={slug}
              instructorId={profile.id}
            />    
          <h3>  Financial Aid </h3>
        </div>
      </div>
    </div>
    <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          <div className="col-md-12 vh-100">
            {studentInfo &&
              (studentInfo[0].finaidlink !== null ? (
                <iframe
                  style={{
                    width: "100%",
                    height: "100%",
                    overflow: "auto",
                  }}
                  src={studentInfo[0].finaidlink}
                ></iframe>
              ) : (
                <div className="d-flex justify-content-center">
                  <h1 className="mt-5">Coming Soon</h1>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}